import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "app-navigation__settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FirstStart = _resolveComponent("FirstStart")!
  const _component_NcAppNavigationItem = _resolveComponent("NcAppNavigationItem")!
  const _component_CogIcon = _resolveComponent("CogIcon")!
  const _component_NcAppNavigation = _resolveComponent("NcAppNavigation")!
  const _component_MobileHeader = _resolveComponent("MobileHeader")!
  const _component_MobileNav = _resolveComponent("MobileNav")!
  const _component_NcAppContent = _resolveComponent("NcAppContent")!
  const _component_Settings = _resolveComponent("Settings")!
  const _component_Viewer = _resolveComponent("Viewer")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_EditMetadataModal = _resolveComponent("EditMetadataModal")!
  const _component_AddToAlbumModal = _resolveComponent("AddToAlbumModal")!
  const _component_NodeShareModal = _resolveComponent("NodeShareModal")!
  const _component_ShareModal = _resolveComponent("ShareModal")!
  const _component_MoveToFolderModal = _resolveComponent("MoveToFolderModal")!
  const _component_FaceMoveModal = _resolveComponent("FaceMoveModal")!
  const _component_AlbumShareModal = _resolveComponent("AlbumShareModal")!
  const _component_UploadModal = _resolveComponent("UploadModal")!
  const _component_SearchModal = _resolveComponent("SearchModal")!
  const _component_NcContent = _resolveComponent("NcContent")!

  return (_openBlock(), _createBlock(_component_NcContent, {
    "app-name": "memories",
    class: _normalizeClass({
      'has-nav': _ctx.showNavigation,
    })
  }, {
    default: _withCtx(() => [
      (_ctx.routeIsNxSetup)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : (_ctx.isFirstStart)
          ? (_openBlock(), _createBlock(_component_FirstStart, { key: 1 }))
          : (!_ctx.isConfigUnknown)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.showNavigation)
                  ? (_openBlock(), _createBlock(_component_NcAppNavigation, {
                      key: 0,
                      "aria-label": _ctx.t('memories', 'Navigation')
                    }, {
                      list: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
                          return (_openBlock(), _createBlock(_component_NcAppNavigationItem, {
                            key: item.name,
                            to: { name: item.name },
                            name: item.title,
                            active: _ctx.$route.name === item.name,
                            onClick: _ctx.linkClick,
                            exact: ""
                          }, {
                            icon: _withCtx(() => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { size: 20 }))
                            ]),
                            _: 2
                          }, 1032, ["to", "name", "active", "onClick"]))
                        }), 128))
                      ]),
                      footer: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_1, [
                          _createVNode(_component_NcAppNavigationItem, {
                            name: _ctx.t('memories', 'Settings'),
                            onClick: _ctx.showSettings,
                            href: "#ss"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CogIcon, { size: 20 })
                            ]),
                            _: 1
                          }, 8, ["name", "onClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["aria-label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_NcAppContent, { allowSwipeNavigation: false }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({
            outer: true,
            'router-outlet': true,
            'has-nav': _ctx.showNavigation,
            'has-mobile-header': _ctx.hasMobileHeader,
            'is-native': _ctx.native,
          })
                    }, [
                      _createVNode(_component_router_view)
                    ], 2),
                    (_ctx.hasMobileHeader)
                      ? (_openBlock(), _createBlock(_component_MobileHeader, { key: 0 }))
                      : _createCommentVNode("", true),
                    (_ctx.showNavigation)
                      ? (_openBlock(), _createBlock(_component_MobileNav, { key: 1 }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Settings, {
                  open: _ctx.settingsOpen,
                  "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settingsOpen) = $event))
                }, null, 8, ["open"]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  _createVNode(_component_Viewer),
                  _createVNode(_component_Sidebar)
                ]))
              ], 64))
            : _createCommentVNode("", true),
      _createVNode(_component_EditMetadataModal),
      _createVNode(_component_AddToAlbumModal),
      _createVNode(_component_NodeShareModal),
      _createVNode(_component_ShareModal),
      _createVNode(_component_MoveToFolderModal),
      _createVNode(_component_FaceMoveModal),
      _createVNode(_component_AlbumShareModal),
      _createVNode(_component_UploadModal),
      _createVNode(_component_SearchModal)
    ]),
    _: 1
  }, 8, ["class"]))
}